import React from 'react';
import { Alert } from '@mui/material';

import { Typography, Button } from '@occc/ui-design-system';
import { useChangeChain } from '@occc-app/Chain/hooks';
import { useGetChains } from '@occc-app/dataAccessLayer/chain/queries';

export interface SwitchChainAlertProps {
  title: React.ReactNode;
  requiredChainId: string;
}

export const SwitchChainAlert: React.FC<SwitchChainAlertProps> = ({ title, requiredChainId }) => {
  const changeChain = useChangeChain();
  const { data: chains } = useGetChains({});

  const handleChangeChain = () => {
    if (!chains) {
      return;
    }

    const chain = chains.find((chain) => chain.id === requiredChainId);

    if (chain) {
      changeChain(chain);
    }
  };

  return (
    <Alert severity='error'>
      <Typography gutterBottom>{title}</Typography>
      <Button onClick={handleChangeChain} disabled={!chains}>
        Switch Chain
      </Button>
    </Alert>
  );
};
